// Older authenticated profiles may omit is_active or use role names directly.
// Explicitly inactive assignments never determine the operational profile.
export function activeProfileRoles(user) {
  return (Array.isArray(user?.roles) ? user.roles : [])
    .filter((role) => typeof role === 'string' || (role && role.is_active !== false))
    .map((role) => typeof role === 'string' ? role : role.role)
    .filter((role) => typeof role === 'string' && role.length > 0);
}

export function isGuardOnlyProfile(user) {
  const roles = activeProfileRoles(user);
  return !user?.is_direccion
    && roles.includes('guardia')
    && !roles.some((role) => ['direccion', 'supervisor', 'administrador'].includes(role));
}
